import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { findToolById } from '@/registry';
import { CATEGORY_BY_ID } from '@/registry/categories';
import { useApp } from '@/store/app';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { ErrorBoundary } from '@/components/ErrorBoundary';

export function ToolPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { pushRecent } = useApp();
  const tool = id ? findToolById(id) : null;

  useEffect(() => {
    if (tool) {
      pushRecent({ toolId: tool.id, toolName: tool.name, category: tool.category });
    }
  }, [tool, pushRecent]);

  if (!tool) {
    return (
      <div className="max-w-6xl mx-auto px-4 sm:px-6 md:px-8 py-6 md:py-10">
        <EmptyState
          title="Tool not found"
          description="This utility doesn't exist or has been moved."
          action={
            <Button variant="primary" onClick={() => navigate('/')}>
              <ArrowLeft size={14} />
              Back to home
            </Button>
          }
        />
      </div>
    );
  }

  const Component = tool.component;
  const cat = CATEGORY_BY_ID[tool.category];

  return (
    <div className="relative">
      {/* ambient tint */}
      <div
        className="absolute top-0 left-1/3 size-[600px] rounded-full opacity-[0.06] blur-3xl pointer-events-none"
        style={{ background: cat?.tint }}
      />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 md:px-8 py-6 md:py-10">
        <ErrorBoundary key={tool.id}>
          <Component />
        </ErrorBoundary>
      </div>
    </div>
  );
}
